import { Modal } from '@atoms/Modal';
import { Badge } from '@atoms/Badge';
import { formatCurrency, formatDate } from '@utils/formatters';
import type { Transaction } from '@/types';

interface TransactionDetailModalProps {
  transaction: Transaction | null;
  onClose: () => void;
}

export function TransactionDetailModal({ transaction, onClose }: TransactionDetailModalProps) {
  return (
    <Modal open={Boolean(transaction)} onClose={onClose} title="İşlem Detayı">
      {transaction && (
        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-500">Tür</span>
            <Badge variant={transaction.type === 'debt' ? 'danger' : 'success'}>
              {transaction.type === 'debt' ? 'Borç' : 'Alacak'}
            </Badge>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Tutar</span>
            <span className="font-bold">{formatCurrency(transaction.amount)}</span>
          </div>
          {transaction.description && (
            <div>
              <p className="text-gray-500">Açıklama</p>
              <p>{transaction.description}</p>
            </div>
          )}
          {transaction.paymentMethod && (
            <div className="flex justify-between">
              <span className="text-gray-500">Ödeme</span>
              <span>{transaction.paymentMethod}</span>
            </div>
          )}
          {transaction.orderId && (
            <div className="flex justify-between">
              <span className="text-gray-500">Sipariş</span>
              <span>#{transaction.orderId.slice(0, 8)}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-gray-500">Tarih</span>
            <span>{formatDate(transaction.createdAt)}</span>
          </div>
        </div>
      )}
    </Modal>
  );
}
